module.exports = __webpack_public_path__ + "static/img/no_msg.af67eff8.png";